package com.essntl.features.tag.ui.alltags

import com.essntl.features.tag.domain.model.TagModel

sealed interface AllTagsNavigation {
    data object AddTag : AllTagsNavigation
    data class EditTag(val tag: TagModel) : AllTagsNavigation
}